import * as React from "react";
import { Button, Chip, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { TeamDialog } from "./teamDialog.component";
import { adminAccountServiceFactory } from "../services/adminAccount.service";
import { AuthContext } from "../auth/auth.context";
import { ErrorSnackBar } from "../components/errorSnackBar.component";
import { Team } from "../models/auth";



export function AccountTeamsContainer(): React.ReactElement<any, any> {
  const [editingTeam, setEditingTeam] = React.useState<Team | undefined>(undefined);
  const [openTeamDialog, setOpenTeamDialog] = React.useState(false);
  const [teams, setTeams] = React.useState<Team[]>([]);
  const [err, setErr] = React.useState("");

  const adminService = adminAccountServiceFactory();
  const authContext = React.useContext<AuthContext>(AuthContext);

  const getTeams = async (accountID: string) => {
    const teams = await adminService.getTeams(accountID);
    setTeams(teams);
  }
  React.useEffect(() => {
    const accountID = authContext.membership?.accountID;
    if (!accountID) return;
    try {
      getTeams(accountID);
    } catch (err) {
      console.log(err)
    }
  }, [])


  async function onConfirmDialog(team: Partial<Team>) {
    const accountID = authContext.membership?.accountID
    if (!accountID) return;
    if (!team.teamColor || team.teamColor.length === 0) {
      setErr("Team color must be selected")
      return;
    }

    if (!team.teamName || team.teamName.length === 0) {
      setErr("Team name must be longer than 0 characters")
      return;
    }

    try {
      //this was an edit vs new creation of team;
      if (editingTeam) {
        team._id = editingTeam._id;
        await adminService.updateTeam(accountID, team);
      }
      else {
        await adminService.createTeam(accountID, team);
      }
      await getTeams(accountID);
      setOpenTeamDialog(false);
      setErr("")
    }
    catch (err: any) {
      console.log(err);
      setErr("Error occured " + err.message || "")
    }
  }

  async function onDeleteTeam(teamID: string) {
    const accountID = authContext.membership?.accountID;
    if (!accountID || !teamID) return;
    try {
      await adminService.deleteTeam(accountID, teamID);
      await getTeams(accountID);
    } catch (err) {
      console.error("Error deleting team:", err);
      setErr("Could not delete team, please try again")
    }
    setOpenTeamDialog(false);
    setEditingTeam(undefined);
  }

  return (
    <div className="account-teams-container">
      <div className="header-area">
        <div>
          <Typography variant="h1" className="title">
            Account Teams
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Manage your account teams and their members
          </Typography>
        </div>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenTeamDialog(true)}
        >
          Add Team
        </Button>
      </div>

      <div className="teams-section">
        {teams.map((team) => (
          <div key={team.teamName} className="team-row team-row-border">
            <div className="team-info">
              <Chip
                label={"@" + team.teamName}
                className="team-chip team-chip-color"
                style={{
                  backgroundColor: team.teamColor,
                }}
              />
              <div className="team-desc">
                <Typography variant="body2" color="textSecondary">
                  {team.teamDesc || "Add team Descripton..."}
                </Typography>
              </div>
            </div>
            <Typography
              variant="body2"
              color="textSecondary"
              className="member-count member-count-border"
            >
              {team.memberCount} members
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                setEditingTeam({
                  _id: team._id,
                  teamColor: team.teamColor,
                  teamDesc: team.teamDesc,
                  teamName: team.teamName,
                  memberCount: team.memberCount
                })
                setOpenTeamDialog(true);
              }}
            >
              <EditIcon />
            </IconButton>
          </div>
        ))}
      </div>
      {openTeamDialog &&
        <TeamDialog
          onDelete={onDeleteTeam}
          onConfirm={(val) => onConfirmDialog(val)}
          open={openTeamDialog}
          isEdit={editingTeam !== undefined}
          desc={editingTeam?.teamDesc}
          name={editingTeam?.teamName}
          hex={editingTeam?.teamColor}
          id={editingTeam?._id}
          onClose={() => {
            setErr("")
            setOpenTeamDialog(false);
            setEditingTeam(undefined);
          }}>
          <ErrorSnackBar errMsg={err} didClose={() => setErr("")}></ErrorSnackBar>
        </TeamDialog>

      }

    </div>
  );
}